var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.027 2.71a.8.8 0 0 1 .237.049l.031.01q.13.055.235.159l4.666 4.667.052.057a.75.75 0 0 1-1.054 1.054l-.058-.05L8.75 5.27v7.521a.75.75 0 0 1-1.5 0V5.268L3.863 8.656a.75.75 0 0 1-1.06-1.061L7.47 2.928l.057-.052.028-.02a.8.8 0 0 1 .174-.095 1 1 0 0 1 .089-.028q.037-.01.076-.017l.011-.002A1 1 0 0 1 8 2.708z"
  })));
};
export default Svg16;